import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, useNavigate } from "react-router-dom";
import {
  setRefetch,
  setRefetchKey,
} from "../../../../features/folder/folderSlice";
import { Tabs } from "antd";
import DetailsList from "./details/DetailsList";
import ViewList from "../view/ViewList";
import DocImages from "../document-image/DocImages";
import Recommendation from "../recommendation/Recommendation";
import Candidates from "../candidate/Candidates";
import { fetchData } from "../../../../features/dropdown/dropdownSlice";

function JobTabs() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [active, setactive] = useState("1");
  async function refetching(activeKey) {
    await dispatch(setRefetch());
    await dispatch(setRefetchKey(activeKey));
    await setactive(activeKey);
  }

  const { viewMode } = useSelector((state) => state.folder);

  const tabData = [
    {
      label: "Job Details",
      key: "1",
      component: viewMode ? (
        <ViewList />
      ) : (
        <DetailsList setactive={setactive} />
      ),
    },
    { label: "Attachment", key: "2", component: <DocImages /> },
    { label: "Candidates", key: "4", component: <Candidates /> },
    { label: "Recommendation", key: "3", component: <Recommendation /> },
  ];

  const tabConfigurations = tabData?.map(({ label, key, component }) => ({
    label: (
      <span className="flex items-center">
        <span>{label}</span>
      </span>
    ),
    key,
    children: component,
  }));
  return (
    <div>
      <Tabs
        items={tabConfigurations}
        defaultActiveKey="1"
        activeKey={active}
        onChange={refetching}
        className="job-tab activity-tab-wrap activity-bar "
      />
    </div>
  );
}

export default JobTabs;
